import { useSuspenseQuery } from '@tanstack/react-query';
import type { User } from '../types';
import queryKeys from './queryKeys';
import type { QueryConfig } from 'lib/react-query';
import { apiClient } from 'lib/api';

interface GetUserDetailsParams {
  id: number;
}

const getUserDetails = async (
  params: GetUserDetailsParams,
  signal?: AbortSignal,
): Promise<User> => {
  const { data } = await apiClient.get<User>(`${queryKeys.users}/${params.id}`, {
    signal,
  });
  return data;
};

interface UseUserDetailsOptions<TData> {
  config?: QueryConfig<typeof getUserDetails, TData>;
  params: GetUserDetailsParams;
}

export const useUserDetails = <TData = User>
({
   params,
   config,
 }: UseUserDetailsOptions<TData>) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getUserDetails(params, signal),
    queryKey: [queryKeys.userDetails, params],
  });
};
